module.exports = __webpack_public_path__ + "static/media/hotel.b6048177.svg";